import React from 'react';
import { withTranslation } from "react-i18next";
import CaAccountModalView from "./CaAccountModalView";

const CaAccountForgotPasswordContainer = props => {

    const newProps = Object.assign({},{
        formFieldsData: [
            {
                type:'email',
                validateAs:'email',
                placeholder: props.t('account_modal.placeholders.email'),
                id:"forgot_email"
            }
        ],
        "title": props.t('account_modal.forgot_password.title'),
        "body": props.t('account_modal.forgot_password.body'),
        "submitCta": props.t('account_modal.forgot_password.submitCta'),
        "success_message": props.t('account_modal.forgot_password.success_message')
    });
    return (
        <CaAccountModalView
            {...Object.assign({},props,newProps)}
        />
    )
}
export default withTranslation("translations")(CaAccountForgotPasswordContainer);